export class Forms {
    constructor(formId, onSubmit) {
        this.formId = formId;
        this.onSubmit = onSubmit;
        const template = document.querySelector(`#${formId}`);
        this.form = template.content.querySelector('form');
        this.button = this.form.querySelector('button[type="submit"]');
        this.errors = this.form.querySelector('.form__errors');
    }
    render() {
        const form = this.form.cloneNode(true);
        this.button = form.querySelector('button[type="submit"]');
        this.errors = form.querySelector('.form__errors');
        // Устанавливаем обработчик отправки формы
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (this.validate()) {
                const formData = new FormData(form);
                const data = Object.fromEntries(formData.entries());
                this.onSubmit(data);
            }
        });
        return form;
    }
    showErrors(errors) {
        if (this.errors) {
            this.errors.textContent = errors.join('. ');
        }
    }
    clearErrors() {
        if (this.errors) {
            this.errors.textContent = '';
        }
    }
}
